<template>
    <v-row no-gutters class="mt-4">
      <v-col cols="12">
          <v-dialog
            v-model="projects_syncing"
            hide-overlay
            persistent
            width="300"
          >
            <v-card
                color="primary"
                dark
            >
                <v-card-text>
                    Loading projects...
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
          </v-dialog>

          <v-card v-if="projects.length" width="100%">
            <v-list subheader two-line>
              <template v-for="(project, index) in projects">
                <v-list-item
                    :key="project.Name"
                    @click="show_project(project, 0)"
                >
                    <v-list-item-content class="pa-0">
                        <v-list-item-title>
                            <span class="caption">{{project.Name}}</span>
                        </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action class="ma-0">
                        <v-btn
                          v-if="ispassword"
                          :disabled="project.deleting"
                          x-small
                          depressed
                          color="success" elevation="24" class="hidden-sm-and-down font-weight-regular" title="Submissions" v-on:click.stop="show_project(project, 0)"
                        >
                          <v-icon x-small left class="mr-0">mdi-group</v-icon>
                          Submissions
                        </v-btn>
                    </v-list-item-action>
                    <v-list-item-action class="ma-0 ml-2">
                        <v-btn
                            v-if="!ispassword"
                            :disabled="project.deleting"
                            x-small
                            depressed
                            color="warning" elevation="24" class="hidden-sm-and-down font-weight-regular" title="Files" v-on:click.stop="show_project(project, 0)"
                        >
                            <v-icon x-small left class="mr-0">mdi-file</v-icon>
                            Files
                        </v-btn>
                        <v-btn 
                            v-if="ispassword"
                            :disabled="project.deleting"
                            x-small
                            depressed
                            color="warning" elevation="24" class="hidden-sm-and-down font-weight-regular" title="Files" v-on:click.stop="show_project(project, 1)"
                        >
                            <v-icon x-small left class="mr-0">mdi-file</v-icon>
                            Files
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>

                <v-divider
                    v-if="index < projects.length - 1"
                    :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
          <v-card v-else>
            <v-card-text v-if="!projects_syncing && ispassword" class="body-2 error--text text-center">
              No projects found. Please submit using the plugin from your modelling application via the <a target="_blank" href="https://www.gridmarkets.com/envoy">Envoy desktop application</a>
            </v-card-text>
            <v-card-text v-if="!projects_syncing && !ispassword" class="body-2 error--text text-center">
              No projects.
            </v-card-text>
          </v-card>
      </v-col>
    </v-row>
</template>

<script>
import axios from 'axios';

export default {
  name: "Projects",
  data() {
    return {
        projects:[],
        projects_syncing: true,
        fetch_interval : null,
        ispassword: false
    }
  },
  methods: {
      _getProjects() {
        axios.get(`https://${this.$assetAPI}/user/resource`)
        .then(resp => {
            this.projects = resp.data.files;
            this.projects_syncing = false;
        })
        .catch(() => {
            this.projects_syncing = false;
        })
      },
      show_project(project, tab_id) {
          this.$router.push({
              path: `/project/${project.Name}/view`,
              query: {
                tab_id: tab_id,
                storage: project.Storage
              }
          });
      },
      _init_fetch_projects(){
        this._getProjects();
        this.fetch_interval = setInterval(()=>{
            this._getProjects();
        },5000)
      },
      _stop_fetch_projects(){
        if (this.fetch_interval){
            clearInterval(this.fetch_interval);
        }
      },
  },
  computed : {
    userLoggedIn : function() { return this.$store.getters.userLoggedIn}
  },
  created () {
    if (this.userLoggedIn.ispassword){
      this.ispassword = true;
    }

    this._init_fetch_projects();
  },
  destroyed (){
    this._stop_fetch_projects();
  }
}
</script>
<style scoped>
    .blink {
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }
</style>